import { getMedicalConditionElements } from "./MedicalConditionSchema";
import { groupedOptions as groupedMedications } from "../../../../models/MedicationData";
import { APIURL } from "../../../../config/api";

// Transform grouped options into SurveyJS choices format
const medicationChoices = groupedMedications.flatMap((group) =>
  group.options.map((option) => ({
    value: option.value,
    text: option.label,
  }))
);

interface MedicalCondition {
  conditionType: string;
}

interface Survey {
  isPerson2: boolean;
  getValue: (path: string) => MedicalCondition[];
}

declare global {
  interface Window {
    survey: Survey;
  }
}

// function getMedicationConditionChoices() {
//   const survey = window.survey;
//   const prefix = survey.isPerson2
//     ? "person2MedicalInformation"
//     : "medicalInformation";
//   const conditions = survey.getValue(`${prefix}.medicalConditionList`) || [];

//   let choices = [{ value: "0", text: "" }];

//   // Map of condition types to medication condition types
//   const conditionTypeMap: Record<string, string> = {
//     "208": "4163", // Other
//     "210": "4165", // Heart
//     "211": "4167", // Diabetes
//     "212": "4161", // Cancer/Tumour
//     "213": "4172", // Stroke
//     "214": "4169", // Respiratory
//     "215": "5983", // Multiple Sclerosis
//     "216": "4170", // Neurological
//     "218": "5873", // High Blood Pressure
//     "219": "5874", // High Cholesterol
//   };

//   // Get unique condition types from medical conditions
//   const uniqueConditionTypes = Array.from(
//     new Set(conditions.map((c: MedicalCondition) => c.conditionType))
//   );

//   // Add corresponding medication condition types
//   uniqueConditionTypes.forEach((type) => {
//     if (conditionTypeMap[type]) {
//       const label = conditions.find(
//         (c: MedicalCondition) => c.conditionType === type
//       )?.conditionType;
//       choices.push({
//         value: conditionTypeMap[type],
//         text: label || type,
//       });
//     }
//   });

//   return choices;
// }

export function getSharedMedicalInfoElements(
  prefix: string,
  isPerson2: boolean
) {
  let yourReplace = isPerson2 ? "their" : "your";
  let youReplace = isPerson2 ? "they" : "you";
  return [
    {
      type: "radiogroup",
      name: `${prefix}.underCareOfConsultant`,
      title: `Are ${youReplace} under the care of a cardiologist?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '210' || {${prefix}.medicalConditionList[1].conditionType} = '210' || {${prefix}.medicalConditionList[2].conditionType} = '210' || {${prefix}.medicalConditionList[3].conditionType} = '210' || {${prefix}.medicalConditionList[4].conditionType} = '210' || {${prefix}.medicalConditionList[5].conditionType} = '210' || {${prefix}.medicalConditionList[6].conditionType} = '210' || {${prefix}.medicalConditionList[7].conditionType} = '210' || {${prefix}.medicalConditionList[8].conditionType} = '210' || {${prefix}.medicalConditionList[9].conditionType} = '210')`,
      isRequired: true,
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "dropdown",
      name: `${prefix}.breathlessnessWalkingRoomtoRoomID`,
      title: `Do ${youReplace} get breathlessness when walking from room to room?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '210' || {${prefix}.medicalConditionList[1].conditionType} = '210' || {${prefix}.medicalConditionList[2].conditionType} = '210' || {${prefix}.medicalConditionList[3].conditionType} = '210' || {${prefix}.medicalConditionList[4].conditionType} = '210' || {${prefix}.medicalConditionList[5].conditionType} = '210' || {${prefix}.medicalConditionList[6].conditionType} = '210' || {${prefix}.medicalConditionList[7].conditionType} = '210' || {${prefix}.medicalConditionList[8].conditionType} = '210' || {${prefix}.medicalConditionList[9].conditionType} = '210' || {${prefix}.medicalConditionList[0].conditionType} = '214' || {${prefix}.medicalConditionList[1].conditionType} = '214' || {${prefix}.medicalConditionList[2].conditionType} = '214' || {${prefix}.medicalConditionList[3].conditionType} = '214' || {${prefix}.medicalConditionList[4].conditionType} = '214' || {${prefix}.medicalConditionList[5].conditionType} = '214' || {${prefix}.medicalConditionList[6].conditionType} = '214' || {${prefix}.medicalConditionList[7].conditionType} = '214' || {${prefix}.medicalConditionList[8].conditionType} = '214' || {${prefix}.medicalConditionList[9].conditionType} = '214')`,
      isRequired: true,
      choices: [
        { value: "5870", text: "Never" },
        { value: "5871", text: "Some Of The Time" },
        { value: "5872", text: "Always" },
        { value: "9935", text: "Most Of The Time" },
      ],
    },
    {
      type: "dropdown",
      name: `${prefix}.breathlessnessClimbingStairsID`,
      title: `Do ${youReplace} get breathlessness climbing stairs?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '210' || {${prefix}.medicalConditionList[1].conditionType} = '210' || {${prefix}.medicalConditionList[2].conditionType} = '210' || {${prefix}.medicalConditionList[3].conditionType} = '210' || {${prefix}.medicalConditionList[4].conditionType} = '210' || {${prefix}.medicalConditionList[5].conditionType} = '210' || {${prefix}.medicalConditionList[6].conditionType} = '210' || {${prefix}.medicalConditionList[7].conditionType} = '210' || {${prefix}.medicalConditionList[8].conditionType} = '210' || {${prefix}.medicalConditionList[9].conditionType} = '210' || {${prefix}.medicalConditionList[0].conditionType} = '214' || {${prefix}.medicalConditionList[1].conditionType} = '214' || {${prefix}.medicalConditionList[2].conditionType} = '214' || {${prefix}.medicalConditionList[3].conditionType} = '214' || {${prefix}.medicalConditionList[4].conditionType} = '214' || {${prefix}.medicalConditionList[5].conditionType} = '214' || {${prefix}.medicalConditionList[6].conditionType} = '214' || {${prefix}.medicalConditionList[7].conditionType} = '214' || {${prefix}.medicalConditionList[8].conditionType} = '214' || {${prefix}.medicalConditionList[9].conditionType} = '214')`,
      isRequired: true,
      choices: [
        { value: "5870", text: "Never" },
        { value: "5871", text: "Some Of The Time" },
        { value: "5872", text: "Always" },
        { value: "9935", text: "Most Of The Time" },
      ],
    },
    {
      type: "dropdown",
      name: `${prefix}.breathlessnessWhenLyingFlatID`,
      title: `Do ${youReplace} get breathlessness when laying flat?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '214' || {${prefix}.medicalConditionList[1].conditionType} = '214' || {${prefix}.medicalConditionList[2].conditionType} = '214' || {${prefix}.medicalConditionList[3].conditionType} = '214' || {${prefix}.medicalConditionList[4].conditionType} = '214' || {${prefix}.medicalConditionList[5].conditionType} = '214' || {${prefix}.medicalConditionList[6].conditionType} = '214' || {${prefix}.medicalConditionList[7].conditionType} = '214' || {${prefix}.medicalConditionList[8].conditionType} = '214' || {${prefix}.medicalConditionList[9].conditionType} = '214')`,
      isRequired: true,
      choices: [
        { value: "5870", text: "Never" },
        { value: "5871", text: "Some Of The Time" },
        { value: "5872", text: "Always" },
        { value: "9935", text: "Most Of The Time" },
      ],
    },
    {
      type: "dropdown",
      name: `${prefix}.needForCPAPBreathingMachineID`,
      title: `Do ${youReplace} need a CPAP Breathing Machine?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '214' || {${prefix}.medicalConditionList[1].conditionType} = '214' || {${prefix}.medicalConditionList[2].conditionType} = '214' || {${prefix}.medicalConditionList[3].conditionType} = '214' || {${prefix}.medicalConditionList[4].conditionType} = '214' || {${prefix}.medicalConditionList[5].conditionType} = '214' || {${prefix}.medicalConditionList[6].conditionType} = '214' || {${prefix}.medicalConditionList[7].conditionType} = '214' || {${prefix}.medicalConditionList[8].conditionType} = '214' || {${prefix}.medicalConditionList[9].conditionType} = '214')`,
      isRequired: true,
      choices: [
        { value: "5870", text: "Never" },
        { value: "5871", text: "Some Of The Time" },
        { value: "5872", text: "Always" },
        { value: "9935", text: "Most Of The Time" },
      ],
    },
    {
      type: "dropdown",
      name: `${prefix}.needForHomeOxygenID`,
      title: `Do ${youReplace} need home oxygen?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '214' || {${prefix}.medicalConditionList[1].conditionType} = '214' || {${prefix}.medicalConditionList[2].conditionType} = '214' || {${prefix}.medicalConditionList[3].conditionType} = '214' || {${prefix}.medicalConditionList[4].conditionType} = '214' || {${prefix}.medicalConditionList[5].conditionType} = '214' || {${prefix}.medicalConditionList[6].conditionType} = '214' || {${prefix}.medicalConditionList[7].conditionType} = '214' || {${prefix}.medicalConditionList[8].conditionType} = '214' || {${prefix}.medicalConditionList[9].conditionType} = '214')`,
      isRequired: true,
      choices: [
        { value: "5870", text: "Never" },
        { value: "5871", text: "Some Of The Time" },
        { value: "5872", text: "Always" },
        { value: "9935", text: "Most Of The Time" },
      ],
    },
    {
      type: "dropdown",
      name: `${prefix}.oralSteroidsID`,
      title: `Do ${youReplace} need oral steroids?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '214' || {${prefix}.medicalConditionList[1].conditionType} = '214' || {${prefix}.medicalConditionList[2].conditionType} = '214' || {${prefix}.medicalConditionList[3].conditionType} = '214' || {${prefix}.medicalConditionList[4].conditionType} = '214' || {${prefix}.medicalConditionList[5].conditionType} = '214' || {${prefix}.medicalConditionList[6].conditionType} = '214' || {${prefix}.medicalConditionList[7].conditionType} = '214' || {${prefix}.medicalConditionList[8].conditionType} = '214' || {${prefix}.medicalConditionList[9].conditionType} = '214')`,
      isRequired: true,
      choices: [
        { value: "5870", text: "Never" },
        { value: "5871", text: "Some Of The Time" },
        { value: "5872", text: "Always" },
        { value: "9935", text: "Most Of The Time" },
      ],
    },
    {
      type: "dropdown",
      name: `${prefix}.recurrentChestInfectionsID`,
      title: `Do ${youReplace} have recurrent chest infections?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '214' || {${prefix}.medicalConditionList[1].conditionType} = '214' || {${prefix}.medicalConditionList[2].conditionType} = '214' || {${prefix}.medicalConditionList[3].conditionType} = '214' || {${prefix}.medicalConditionList[4].conditionType} = '214' || {${prefix}.medicalConditionList[5].conditionType} = '214' || {${prefix}.medicalConditionList[6].conditionType} = '214' || {${prefix}.medicalConditionList[7].conditionType} = '214' || {${prefix}.medicalConditionList[8].conditionType} = '214' || {${prefix}.medicalConditionList[9].conditionType} = '214')`,
      isRequired: true,
      choices: [
        { value: "5870", text: "Never" },
        { value: "5871", text: "Some Of The Time" },
        { value: "5872", text: "Always" },
        { value: "9935", text: "Most Of The Time" },
      ],
    },
    {
      type: "dropdown",
      name: `${prefix}.signsOfCorPulmonaleID`,
      title: `Do ${youReplace} have signs of cor pulmonale (right heart failure due to lung disease)?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '214' || {${prefix}.medicalConditionList[1].conditionType} = '214' || {${prefix}.medicalConditionList[2].conditionType} = '214' || {${prefix}.medicalConditionList[3].conditionType} = '214' || {${prefix}.medicalConditionList[4].conditionType} = '214' || {${prefix}.medicalConditionList[5].conditionType} = '214' || {${prefix}.medicalConditionList[6].conditionType} = '214' || {${prefix}.medicalConditionList[7].conditionType} = '214' || {${prefix}.medicalConditionList[8].conditionType} = '214' || {${prefix}.medicalConditionList[9].conditionType} = '214')`,
      isRequired: true,
      choices: [
        { value: "5870", text: "Never" },
        { value: "5871", text: "Some Of The Time" },
        { value: "5872", text: "Always" },
        { value: "9935", text: "Most Of The Time" },
      ],
    },
    {
      type: "dropdown",
      name: `${prefix}.chestPainsOnModerateActivityID`,
      title: `Do ${youReplace} get chest pains doing moderate activity?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '210' || {${prefix}.medicalConditionList[1].conditionType} = '210' || {${prefix}.medicalConditionList[2].conditionType} = '210' || {${prefix}.medicalConditionList[3].conditionType} = '210' || {${prefix}.medicalConditionList[4].conditionType} = '210' || {${prefix}.medicalConditionList[5].conditionType} = '210' || {${prefix}.medicalConditionList[6].conditionType} = '210' || {${prefix}.medicalConditionList[7].conditionType} = '210' || {${prefix}.medicalConditionList[8].conditionType} = '210' || {${prefix}.medicalConditionList[9].conditionType} = '210')`,
      isRequired: true,
      choices: [
        { value: "5870", text: "Never" },
        { value: "5871", text: "Some Of The Time" },
        { value: "5872", text: "Always" },
        { value: "9935", text: "Most Of The Time" },
      ],
    },
    {
      type: "dropdown",
      name: `${prefix}.chestPainsOnSevereExertionID`,
      title: `Do ${youReplace} get chest pains on severe exertion?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '210' || {${prefix}.medicalConditionList[1].conditionType} = '210' || {${prefix}.medicalConditionList[2].conditionType} = '210' || {${prefix}.medicalConditionList[3].conditionType} = '210' || {${prefix}.medicalConditionList[4].conditionType} = '210' || {${prefix}.medicalConditionList[5].conditionType} = '210' || {${prefix}.medicalConditionList[6].conditionType} = '210' || {${prefix}.medicalConditionList[7].conditionType} = '210' || {${prefix}.medicalConditionList[8].conditionType} = '210' || {${prefix}.medicalConditionList[9].conditionType} = '210')`,
      isRequired: true,
      choices: [
        { value: "5870", text: "Never" },
        { value: "5871", text: "Some Of The Time" },
        { value: "5872", text: "Always" },
        { value: "9935", text: "Most Of The Time" },
      ],
    },
    {
      type: "dropdown",
      name: `${prefix}.episodesOfDizzinessID`,
      title: `Do ${youReplace} experience episodes of dizziness?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '210' || {${prefix}.medicalConditionList[1].conditionType} = '210' || {${prefix}.medicalConditionList[2].conditionType} = '210' || {${prefix}.medicalConditionList[3].conditionType} = '210' || {${prefix}.medicalConditionList[4].conditionType} = '210' || {${prefix}.medicalConditionList[5].conditionType} = '210' || {${prefix}.medicalConditionList[6].conditionType} = '210' || {${prefix}.medicalConditionList[7].conditionType} = '210' || {${prefix}.medicalConditionList[8].conditionType} = '210' || {${prefix}.medicalConditionList[9].conditionType} = '210')`,
      isRequired: true,
      choices: [
        { value: "5870", text: "Never" },
        { value: "5871", text: "Some Of The Time" },
        { value: "5872", text: "Always" },
        { value: "9935", text: "Most Of The Time" },
      ],
    },
    {
      type: "dropdown",
      name: `${prefix}.episodesOfBlackoutsID`,
      title: `Do ${youReplace} experience episodes of blackouts?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '210' || {${prefix}.medicalConditionList[1].conditionType} = '210' || {${prefix}.medicalConditionList[2].conditionType} = '210' || {${prefix}.medicalConditionList[3].conditionType} = '210' || {${prefix}.medicalConditionList[4].conditionType} = '210' || {${prefix}.medicalConditionList[5].conditionType} = '210' || {${prefix}.medicalConditionList[6].conditionType} = '210' || {${prefix}.medicalConditionList[7].conditionType} = '210' || {${prefix}.medicalConditionList[8].conditionType} = '210' || {${prefix}.medicalConditionList[9].conditionType} = '210')`,
      isRequired: true,
      choices: [
        { value: "5870", text: "Never" },
        { value: "5871", text: "Some Of The Time" },
        { value: "5872", text: "Always" },
        { value: "9935", text: "Most Of The Time" },
      ],
    },
    {
      type: "dropdown",
      name: `${prefix}.symptomsAtRestID`,
      title: `Do ${youReplace} experience symptoms of your conditions while at rest?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '210' || {${prefix}.medicalConditionList[1].conditionType} = '210' || {${prefix}.medicalConditionList[2].conditionType} = '210' || {${prefix}.medicalConditionList[3].conditionType} = '210' || {${prefix}.medicalConditionList[4].conditionType} = '210' || {${prefix}.medicalConditionList[5].conditionType} = '210' || {${prefix}.medicalConditionList[6].conditionType} = '210' || {${prefix}.medicalConditionList[7].conditionType} = '210' || {${prefix}.medicalConditionList[8].conditionType} = '210' || {${prefix}.medicalConditionList[9].conditionType} = '210')`,
      isRequired: true,
      choices: [
        { value: "5870", text: "Never" },
        { value: "5871", text: "Some Of The Time" },
        { value: "5872", text: "Always" },
        { value: "9935", text: "Most Of The Time" },
      ],
    },
    {
      type: "dropdown",
      name: `${prefix}.swollenAnklesID`,
      title: `Do ${youReplace} get swollen ankles?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '210' || {${prefix}.medicalConditionList[1].conditionType} = '210' || {${prefix}.medicalConditionList[2].conditionType} = '210' || {${prefix}.medicalConditionList[3].conditionType} = '210' || {${prefix}.medicalConditionList[4].conditionType} = '210' || {${prefix}.medicalConditionList[5].conditionType} = '210' || {${prefix}.medicalConditionList[6].conditionType} = '210' || {${prefix}.medicalConditionList[7].conditionType} = '210' || {${prefix}.medicalConditionList[8].conditionType} = '210' || {${prefix}.medicalConditionList[9].conditionType} = '210')`,
      isRequired: true,
      choices: [
        { value: "5870", text: "Never" },
        { value: "5871", text: "Some Of The Time" },
        { value: "5872", text: "Always" },
        { value: "9935", text: "Most Of The Time" },
      ],
    },
    {
      type: "dropdown",
      name: `${prefix}.transferringID`,
      title: `Which of the following most closely reflects ${youReplace} transferring ability? (Problems with sitting unaided)?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '213' || {${prefix}.medicalConditionList[1].conditionType} = '213' || {${prefix}.medicalConditionList[2].conditionType} = '213' || {${prefix}.medicalConditionList[3].conditionType} = '213' || {${prefix}.medicalConditionList[4].conditionType} = '213' || {${prefix}.medicalConditionList[5].conditionType} = '213' || {${prefix}.medicalConditionList[6].conditionType} = '213' || {${prefix}.medicalConditionList[7].conditionType} = '213' || {${prefix}.medicalConditionList[8].conditionType} = '213' || {${prefix}.medicalConditionList[9].conditionType} = '213' || {${prefix}.medicalConditionList[0].conditionType} = '214' || {${prefix}.medicalConditionList[1].conditionType} = '214' || {${prefix}.medicalConditionList[2].conditionType} = '214' || {${prefix}.medicalConditionList[3].conditionType} = '214' || {${prefix}.medicalConditionList[4].conditionType} = '214' || {${prefix}.medicalConditionList[5].conditionType} = '214' || {${prefix}.medicalConditionList[6].conditionType} = '214' || {${prefix}.medicalConditionList[7].conditionType} = '214' || {${prefix}.medicalConditionList[8].conditionType} = '214' || {${prefix}.medicalConditionList[9].conditionType} = '214' || {${prefix}.medicalConditionList[0].conditionType} = '215' || {${prefix}.medicalConditionList[1].conditionType} = '215' || {${prefix}.medicalConditionList[2].conditionType} = '215' || {${prefix}.medicalConditionList[3].conditionType} = '215' || {${prefix}.medicalConditionList[4].conditionType} = '215' || {${prefix}.medicalConditionList[5].conditionType} = '215' || {${prefix}.medicalConditionList[6].conditionType} = '215' || {${prefix}.medicalConditionList[7].conditionType} = '215' || {${prefix}.medicalConditionList[8].conditionType} = '215' || {${prefix}.medicalConditionList[9].conditionType} = '215' || {${prefix}.medicalConditionList[0].conditionType} = '216' || {${prefix}.medicalConditionList[1].conditionType} = '216' || {${prefix}.medicalConditionList[2].conditionType} = '216' || {${prefix}.medicalConditionList[3].conditionType} = '216' || {${prefix}.medicalConditionList[4].conditionType} = '216' || {${prefix}.medicalConditionList[5].conditionType} = '216' || {${prefix}.medicalConditionList[6].conditionType} = '216' || {${prefix}.medicalConditionList[7].conditionType} = '216' || {${prefix}.medicalConditionList[8].conditionType} = '216' || {${prefix}.medicalConditionList[9].conditionType} = '216')`,
      isRequired: true,
      choices: [
        { value: "5856", text: "Unable, no sitting balance" },
        { value: "5857", text: "Major Help" },
        { value: "5858", text: "Minor help, can sit unaided" },
        { value: "5859", text: "Independent" },
      ],
    },
    {
      type: "dropdown",
      name: `${prefix}.mobilityID`,
      title: `Which of the following most closely reflects ${youReplace} mobility?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '213' || {${prefix}.medicalConditionList[1].conditionType} = '213' || {${prefix}.medicalConditionList[2].conditionType} = '213' || {${prefix}.medicalConditionList[3].conditionType} = '213' || {${prefix}.medicalConditionList[4].conditionType} = '213' || {${prefix}.medicalConditionList[5].conditionType} = '213' || {${prefix}.medicalConditionList[6].conditionType} = '213' || {${prefix}.medicalConditionList[7].conditionType} = '213' || {${prefix}.medicalConditionList[8].conditionType} = '213' || {${prefix}.medicalConditionList[9].conditionType} = '213' || {${prefix}.medicalConditionList[0].conditionType} = '214' || {${prefix}.medicalConditionList[1].conditionType} = '214' || {${prefix}.medicalConditionList[2].conditionType} = '214' || {${prefix}.medicalConditionList[3].conditionType} = '214' || {${prefix}.medicalConditionList[4].conditionType} = '214' || {${prefix}.medicalConditionList[5].conditionType} = '214' || {${prefix}.medicalConditionList[6].conditionType} = '214' || {${prefix}.medicalConditionList[7].conditionType} = '214' || {${prefix}.medicalConditionList[8].conditionType} = '214' || {${prefix}.medicalConditionList[9].conditionType} = '214' || {${prefix}.medicalConditionList[0].conditionType} = '215' || {${prefix}.medicalConditionList[1].conditionType} = '215' || {${prefix}.medicalConditionList[2].conditionType} = '215' || {${prefix}.medicalConditionList[3].conditionType} = '215' || {${prefix}.medicalConditionList[4].conditionType} = '215' || {${prefix}.medicalConditionList[5].conditionType} = '215' || {${prefix}.medicalConditionList[6].conditionType} = '215' || {${prefix}.medicalConditionList[7].conditionType} = '215' || {${prefix}.medicalConditionList[8].conditionType} = '215' || {${prefix}.medicalConditionList[9].conditionType} = '215' || {${prefix}.medicalConditionList[0].conditionType} = '216' || {${prefix}.medicalConditionList[1].conditionType} = '216' || {${prefix}.medicalConditionList[2].conditionType} = '216' || {${prefix}.medicalConditionList[3].conditionType} = '216' || {${prefix}.medicalConditionList[4].conditionType} = '216' || {${prefix}.medicalConditionList[5].conditionType} = '216' || {${prefix}.medicalConditionList[6].conditionType} = '216' || {${prefix}.medicalConditionList[7].conditionType} = '216' || {${prefix}.medicalConditionList[8].conditionType} = '216' || {${prefix}.medicalConditionList[9].conditionType} = '216')`,
      isRequired: true,
      choices: [
        { value: "5815", text: "Independent (needs no assistance)" },
        { value: "5816", text: "Walks with assistance (frame/stick etc.)" },
        { value: "5817", text: "Wheelchair use - permanent" },
        { value: "5818", text: "In need of daily nursing care" },
        { value: "5819", text: "Bedridden" },
        { value: "100992", text: "Wheelchair use - non permanent" },
      ],
    },
    {
      type: "dropdown",
      name: `${prefix}.dressingID`,
      title: `Which of the following most closely reflects ${youReplace} ability to dress each day? (Zips, laces, buttons, general dressing)?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '213' || {${prefix}.medicalConditionList[1].conditionType} = '213' || {${prefix}.medicalConditionList[2].conditionType} = '213' || {${prefix}.medicalConditionList[3].conditionType} = '213' || {${prefix}.medicalConditionList[4].conditionType} = '213' || {${prefix}.medicalConditionList[5].conditionType} = '213' || {${prefix}.medicalConditionList[6].conditionType} = '213' || {${prefix}.medicalConditionList[7].conditionType} = '213' || {${prefix}.medicalConditionList[8].conditionType} = '213' || {${prefix}.medicalConditionList[9].conditionType} = '213' || {${prefix}.medicalConditionList[0].conditionType} = '214' || {${prefix}.medicalConditionList[1].conditionType} = '214' || {${prefix}.medicalConditionList[2].conditionType} = '214' || {${prefix}.medicalConditionList[3].conditionType} = '214' || {${prefix}.medicalConditionList[4].conditionType} = '214' || {${prefix}.medicalConditionList[5].conditionType} = '214' || {${prefix}.medicalConditionList[6].conditionType} = '214' || {${prefix}.medicalConditionList[7].conditionType} = '214' || {${prefix}.medicalConditionList[8].conditionType} = '214' || {${prefix}.medicalConditionList[9].conditionType} = '214' || {${prefix}.medicalConditionList[0].conditionType} = '215' || {${prefix}.medicalConditionList[1].conditionType} = '215' || {${prefix}.medicalConditionList[2].conditionType} = '215' || {${prefix}.medicalConditionList[3].conditionType} = '215' || {${prefix}.medicalConditionList[4].conditionType} = '215' || {${prefix}.medicalConditionList[5].conditionType} = '215' || {${prefix}.medicalConditionList[6].conditionType} = '215' || {${prefix}.medicalConditionList[7].conditionType} = '215' || {${prefix}.medicalConditionList[8].conditionType} = '215' || {${prefix}.medicalConditionList[9].conditionType} = '215' || {${prefix}.medicalConditionList[0].conditionType} = '216' || {${prefix}.medicalConditionList[1].conditionType} = '216' || {${prefix}.medicalConditionList[2].conditionType} = '216' || {${prefix}.medicalConditionList[3].conditionType} = '216' || {${prefix}.medicalConditionList[4].conditionType} = '216' || {${prefix}.medicalConditionList[5].conditionType} = '216' || {${prefix}.medicalConditionList[6].conditionType} = '216' || {${prefix}.medicalConditionList[7].conditionType} = '216' || {${prefix}.medicalConditionList[8].conditionType} = '216' || {${prefix}.medicalConditionList[9].conditionType} = '216')`,
      isRequired: true,
      choices: [
        { value: "5838", text: "Dependent, requires full assistance" },
        { value: "5839", text: "Needs help, but can do about half unaided" },
        {
          value: "5840",
          text: "Independent (including buttons, zips, laces, etc)",
        },
      ],
    },
    {
      type: "dropdown",
      name: `${prefix}.bowelsID`,
      title: `Which of the following most closely reflects ${youReplace} bowel control`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '213' || {${prefix}.medicalConditionList[1].conditionType} = '213' || {${prefix}.medicalConditionList[2].conditionType} = '213' || {${prefix}.medicalConditionList[3].conditionType} = '213' || {${prefix}.medicalConditionList[4].conditionType} = '213' || {${prefix}.medicalConditionList[5].conditionType} = '213' || {${prefix}.medicalConditionList[6].conditionType} = '213' || {${prefix}.medicalConditionList[7].conditionType} = '213' || {${prefix}.medicalConditionList[8].conditionType} = '213' || {${prefix}.medicalConditionList[9].conditionType} = '213' || {${prefix}.medicalConditionList[0].conditionType} = '214' || {${prefix}.medicalConditionList[1].conditionType} = '214' || {${prefix}.medicalConditionList[2].conditionType} = '214' || {${prefix}.medicalConditionList[3].conditionType} = '214' || {${prefix}.medicalConditionList[4].conditionType} = '214' || {${prefix}.medicalConditionList[5].conditionType} = '214' || {${prefix}.medicalConditionList[6].conditionType} = '214' || {${prefix}.medicalConditionList[7].conditionType} = '214' || {${prefix}.medicalConditionList[8].conditionType} = '214' || {${prefix}.medicalConditionList[9].conditionType} = '214' || {${prefix}.medicalConditionList[0].conditionType} = '215' || {${prefix}.medicalConditionList[1].conditionType} = '215' || {${prefix}.medicalConditionList[2].conditionType} = '215' || {${prefix}.medicalConditionList[3].conditionType} = '215' || {${prefix}.medicalConditionList[4].conditionType} = '215' || {${prefix}.medicalConditionList[5].conditionType} = '215' || {${prefix}.medicalConditionList[6].conditionType} = '215' || {${prefix}.medicalConditionList[7].conditionType} = '215' || {${prefix}.medicalConditionList[8].conditionType} = '215' || {${prefix}.medicalConditionList[9].conditionType} = '215' || {${prefix}.medicalConditionList[0].conditionType} = '216' || {${prefix}.medicalConditionList[1].conditionType} = '216' || {${prefix}.medicalConditionList[2].conditionType} = '216' || {${prefix}.medicalConditionList[3].conditionType} = '216' || {${prefix}.medicalConditionList[4].conditionType} = '216' || {${prefix}.medicalConditionList[5].conditionType} = '216' || {${prefix}.medicalConditionList[6].conditionType} = '216' || {${prefix}.medicalConditionList[7].conditionType} = '216' || {${prefix}.medicalConditionList[8].conditionType} = '216' || {${prefix}.medicalConditionList[9].conditionType} = '216')`,
      isRequired: true,
      choices: [
        { value: "5847", text: "Incontinent (or requires enema)" },
        { value: "5848", text: "Occasional accident (once a week)" },
        { value: "5849", text: "Continent" },
      ],
    },
    {
      type: "dropdown",
      name: `${prefix}.bladderID`,
      title: `Which of the following most closely reflects ${youReplace} bladder control?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '213' || {${prefix}.medicalConditionList[1].conditionType} = '213' || {${prefix}.medicalConditionList[2].conditionType} = '213' || {${prefix}.medicalConditionList[3].conditionType} = '213' || {${prefix}.medicalConditionList[4].conditionType} = '213' || {${prefix}.medicalConditionList[5].conditionType} = '213' || {${prefix}.medicalConditionList[6].conditionType} = '213' || {${prefix}.medicalConditionList[7].conditionType} = '213' || {${prefix}.medicalConditionList[8].conditionType} = '213' || {${prefix}.medicalConditionList[9].conditionType} = '213' || {${prefix}.medicalConditionList[0].conditionType} = '214' || {${prefix}.medicalConditionList[1].conditionType} = '214' || {${prefix}.medicalConditionList[2].conditionType} = '214' || {${prefix}.medicalConditionList[3].conditionType} = '214' || {${prefix}.medicalConditionList[4].conditionType} = '214' || {${prefix}.medicalConditionList[5].conditionType} = '214' || {${prefix}.medicalConditionList[6].conditionType} = '214' || {${prefix}.medicalConditionList[7].conditionType} = '214' || {${prefix}.medicalConditionList[8].conditionType} = '214' || {${prefix}.medicalConditionList[9].conditionType} = '214' || {${prefix}.medicalConditionList[0].conditionType} = '215' || {${prefix}.medicalConditionList[1].conditionType} = '215' || {${prefix}.medicalConditionList[2].conditionType} = '215' || {${prefix}.medicalConditionList[3].conditionType} = '215' || {${prefix}.medicalConditionList[4].conditionType} = '215' || {${prefix}.medicalConditionList[5].conditionType} = '215' || {${prefix}.medicalConditionList[6].conditionType} = '215' || {${prefix}.medicalConditionList[7].conditionType} = '215' || {${prefix}.medicalConditionList[8].conditionType} = '215' || {${prefix}.medicalConditionList[9].conditionType} = '215' || {${prefix}.medicalConditionList[0].conditionType} = '216' || {${prefix}.medicalConditionList[1].conditionType} = '216' || {${prefix}.medicalConditionList[2].conditionType} = '216' || {${prefix}.medicalConditionList[3].conditionType} = '216' || {${prefix}.medicalConditionList[4].conditionType} = '216' || {${prefix}.medicalConditionList[5].conditionType} = '216' || {${prefix}.medicalConditionList[6].conditionType} = '216' || {${prefix}.medicalConditionList[7].conditionType} = '216' || {${prefix}.medicalConditionList[8].conditionType} = '216' || {${prefix}.medicalConditionList[9].conditionType} = '216')`,
      isRequired: true,
      choices: [
        {
          value: "5844",
          text: "Incontinent/catheterised/unable to manage alone",
        },
        { value: "5845", text: "Occasional accident (once a week)" },
        { value: "5846", text: "Continent" },
      ],
    },
    {
      type: "dropdown",
      name: `${prefix}.bathingID`,
      title: `Which of the following most closely reflects ${youReplace} ability to bathe each day?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '213' || {${prefix}.medicalConditionList[1].conditionType} = '213' || {${prefix}.medicalConditionList[2].conditionType} = '213' || {${prefix}.medicalConditionList[3].conditionType} = '213' || {${prefix}.medicalConditionList[4].conditionType} = '213' || {${prefix}.medicalConditionList[5].conditionType} = '213' || {${prefix}.medicalConditionList[6].conditionType} = '213' || {${prefix}.medicalConditionList[7].conditionType} = '213' || {${prefix}.medicalConditionList[8].conditionType} = '213' || {${prefix}.medicalConditionList[9].conditionType} = '213' || {${prefix}.medicalConditionList[0].conditionType} = '214' || {${prefix}.medicalConditionList[1].conditionType} = '214' || {${prefix}.medicalConditionList[2].conditionType} = '214' || {${prefix}.medicalConditionList[3].conditionType} = '214' || {${prefix}.medicalConditionList[4].conditionType} = '214' || {${prefix}.medicalConditionList[5].conditionType} = '214' || {${prefix}.medicalConditionList[6].conditionType} = '214' || {${prefix}.medicalConditionList[7].conditionType} = '214' || {${prefix}.medicalConditionList[8].conditionType} = '214' || {${prefix}.medicalConditionList[9].conditionType} = '214' || {${prefix}.medicalConditionList[0].conditionType} = '215' || {${prefix}.medicalConditionList[1].conditionType} = '215' || {${prefix}.medicalConditionList[2].conditionType} = '215' || {${prefix}.medicalConditionList[3].conditionType} = '215' || {${prefix}.medicalConditionList[4].conditionType} = '215' || {${prefix}.medicalConditionList[5].conditionType} = '215' || {${prefix}.medicalConditionList[6].conditionType} = '215' || {${prefix}.medicalConditionList[7].conditionType} = '215' || {${prefix}.medicalConditionList[8].conditionType} = '215' || {${prefix}.medicalConditionList[9].conditionType} = '215' || {${prefix}.medicalConditionList[0].conditionType} = '216' || {${prefix}.medicalConditionList[1].conditionType} = '216' || {${prefix}.medicalConditionList[2].conditionType} = '216' || {${prefix}.medicalConditionList[3].conditionType} = '216' || {${prefix}.medicalConditionList[4].conditionType} = '216' || {${prefix}.medicalConditionList[5].conditionType} = '216' || {${prefix}.medicalConditionList[6].conditionType} = '216' || {${prefix}.medicalConditionList[7].conditionType} = '216' || {${prefix}.medicalConditionList[8].conditionType} = '216' || {${prefix}.medicalConditionList[9].conditionType} = '216')`,
      isRequired: true,
      choices: [
        { value: "5841", text: "Dependent" },
        { value: "5842", text: "Needs some assistance" },
        { value: "5843", text: "Independent" },
      ],
    },
    {
      type: "dropdown",
      name: `${prefix}.lungFunctionID`,
      title: `How is ${youReplace} lung function?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '214' || {${prefix}.medicalConditionList[1].conditionType} = '214' || {${prefix}.medicalConditionList[2].conditionType} = '214' || {${prefix}.medicalConditionList[3].conditionType} = '214' || {${prefix}.medicalConditionList[4].conditionType} = '214' || {${prefix}.medicalConditionList[5].conditionType} = '214' || {${prefix}.medicalConditionList[6].conditionType} = '214' || {${prefix}.medicalConditionList[7].conditionType} = '214' || {${prefix}.medicalConditionList[8].conditionType} = '214' || {${prefix}.medicalConditionList[9].conditionType} = '214')`,
      isRequired: true,
      choices: [
        { value: "5867", text: "Minimally Impaired (FEV1 >70%)" },
        { value: "5868", text: "Moderately Impaired (FEV1 50-70%)" },
        { value: "5869", text: "Severely Impaired (FEV1 <50%)" },
      ],
    },
    {
      type: "dropdown",
      name: `${prefix}.feedingID`,
      title: `Which of the following most closely reflects ${youReplace} ability to feed each day?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '213' || {${prefix}.medicalConditionList[1].conditionType} = '213' || {${prefix}.medicalConditionList[2].conditionType} = '213' || {${prefix}.medicalConditionList[3].conditionType} = '213' || {${prefix}.medicalConditionList[4].conditionType} = '213' || {${prefix}.medicalConditionList[5].conditionType} = '213' || {${prefix}.medicalConditionList[6].conditionType} = '213' || {${prefix}.medicalConditionList[7].conditionType} = '213' || {${prefix}.medicalConditionList[8].conditionType} = '213' || {${prefix}.medicalConditionList[9].conditionType} = '213' || {${prefix}.medicalConditionList[0].conditionType} = '214' || {${prefix}.medicalConditionList[1].conditionType} = '214' || {${prefix}.medicalConditionList[2].conditionType} = '214' || {${prefix}.medicalConditionList[3].conditionType} = '214' || {${prefix}.medicalConditionList[4].conditionType} = '214' || {${prefix}.medicalConditionList[5].conditionType} = '214' || {${prefix}.medicalConditionList[6].conditionType} = '214' || {${prefix}.medicalConditionList[7].conditionType} = '214' || {${prefix}.medicalConditionList[8].conditionType} = '214' || {${prefix}.medicalConditionList[9].conditionType} = '214' || {${prefix}.medicalConditionList[0].conditionType} = '215' || {${prefix}.medicalConditionList[1].conditionType} = '215' || {${prefix}.medicalConditionList[2].conditionType} = '215' || {${prefix}.medicalConditionList[3].conditionType} = '215' || {${prefix}.medicalConditionList[4].conditionType} = '215' || {${prefix}.medicalConditionList[5].conditionType} = '215' || {${prefix}.medicalConditionList[6].conditionType} = '215' || {${prefix}.medicalConditionList[7].conditionType} = '215' || {${prefix}.medicalConditionList[8].conditionType} = '215' || {${prefix}.medicalConditionList[9].conditionType} = '215' || {${prefix}.medicalConditionList[0].conditionType} = '216' || {${prefix}.medicalConditionList[1].conditionType} = '216' || {${prefix}.medicalConditionList[2].conditionType} = '216' || {${prefix}.medicalConditionList[3].conditionType} = '216' || {${prefix}.medicalConditionList[4].conditionType} = '216' || {${prefix}.medicalConditionList[5].conditionType} = '216' || {${prefix}.medicalConditionList[6].conditionType} = '216' || {${prefix}.medicalConditionList[7].conditionType} = '216' || {${prefix}.medicalConditionList[8].conditionType} = '216' || {${prefix}.medicalConditionList[9].conditionType} = '216')`,
      isRequired: true,
      choices: [
        { value: "5850", text: "Unable (naso-gastric tube/PEG tube in place)" },
        {
          value: "5851",
          text: "Needs some help cutting, spreading butter, etc",
        },
        { value: "5852", text: "Independent" },
      ],
    },
    {
      type: "dropdown",
      name: `${prefix}.progressionID`,
      title: `In relation to ${youReplace} condition(s), has their been any change in the last five years?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '213' || {${prefix}.medicalConditionList[1].conditionType} = '213' || {${prefix}.medicalConditionList[2].conditionType} = '213' || {${prefix}.medicalConditionList[3].conditionType} = '213' || {${prefix}.medicalConditionList[4].conditionType} = '213' || {${prefix}.medicalConditionList[5].conditionType} = '213' || {${prefix}.medicalConditionList[6].conditionType} = '213' || {${prefix}.medicalConditionList[7].conditionType} = '213' || {${prefix}.medicalConditionList[8].conditionType} = '213' || {${prefix}.medicalConditionList[9].conditionType} = '213' || {${prefix}.medicalConditionList[0].conditionType} = '214' || {${prefix}.medicalConditionList[1].conditionType} = '214' || {${prefix}.medicalConditionList[2].conditionType} = '214' || {${prefix}.medicalConditionList[3].conditionType} = '214' || {${prefix}.medicalConditionList[4].conditionType} = '214' || {${prefix}.medicalConditionList[5].conditionType} = '214' || {${prefix}.medicalConditionList[6].conditionType} = '214' || {${prefix}.medicalConditionList[7].conditionType} = '214' || {${prefix}.medicalConditionList[8].conditionType} = '214' || {${prefix}.medicalConditionList[9].conditionType} = '214' || {${prefix}.medicalConditionList[0].conditionType} = '215' || {${prefix}.medicalConditionList[1].conditionType} = '215' || {${prefix}.medicalConditionList[2].conditionType} = '215' || {${prefix}.medicalConditionList[3].conditionType} = '215' || {${prefix}.medicalConditionList[4].conditionType} = '215' || {${prefix}.medicalConditionList[5].conditionType} = '215' || {${prefix}.medicalConditionList[6].conditionType} = '215' || {${prefix}.medicalConditionList[7].conditionType} = '215' || {${prefix}.medicalConditionList[8].conditionType} = '215' || {${prefix}.medicalConditionList[9].conditionType} = '215' || {${prefix}.medicalConditionList[0].conditionType} = '216' || {${prefix}.medicalConditionList[1].conditionType} = '216' || {${prefix}.medicalConditionList[2].conditionType} = '216' || {${prefix}.medicalConditionList[3].conditionType} = '216' || {${prefix}.medicalConditionList[4].conditionType} = '216' || {${prefix}.medicalConditionList[5].conditionType} = '216' || {${prefix}.medicalConditionList[6].conditionType} = '216' || {${prefix}.medicalConditionList[7].conditionType} = '216' || {${prefix}.medicalConditionList[8].conditionType} = '216' || {${prefix}.medicalConditionList[9].conditionType} = '216')`,
      isRequired: true,
      choices: [
        { value: "5853", text: "Stable (no/minimal change)" },
        {
          value: "5854",
          text: "Deteriorating (impact to 2 or more activities above/acute episodes)",
        },
        { value: "5855", text: "Rapid Deterioration" },
      ],
    },
    {
      type: "dropdown",
      name: `${prefix}.futureTreatmentPlannedID`,
      title: `Do ${youReplace} have any of the following surgeries or treatments planned?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '210' || {${prefix}.medicalConditionList[1].conditionType} = '210' || {${prefix}.medicalConditionList[2].conditionType} = '210' || {${prefix}.medicalConditionList[3].conditionType} = '210' || {${prefix}.medicalConditionList[4].conditionType} = '210' || {${prefix}.medicalConditionList[5].conditionType} = '210' || {${prefix}.medicalConditionList[6].conditionType} = '210' || {${prefix}.medicalConditionList[7].conditionType} = '210' || {${prefix}.medicalConditionList[8].conditionType} = '210' || {${prefix}.medicalConditionList[9].conditionType} = '210')`,
      isRequired: false,
      choices: [
        { value: "6013", text: "No Treatment Planned" },
        { value: "6005", text: "Coronary artery bypass graft (CABG)" },
        { value: "6006", text: "Coronary angioplasty/stents" },
        { value: "6007", text: "Aortic valve replacement" },
        { value: "6008", text: "Mitral valve replacement" },
        { value: "6009", text: "Tricuspid valve replacement" },
        { value: "6010", text: "Pacemaker" },
        { value: "6011", text: "Cardioversion/ablation" },
        { value: "6012", text: "Aortic aneurysm repair" },
      ],
    },
    {
      type: "text",
      name: `${prefix}.lastECGDate`,
      title: `Do ${youReplace} have the latest date of any stress (exercise) ECG test e.g. using a bicycle or treadmill?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '210' || {${prefix}.medicalConditionList[1].conditionType} = '210' || {${prefix}.medicalConditionList[2].conditionType} = '210' || {${prefix}.medicalConditionList[3].conditionType} = '210' || {${prefix}.medicalConditionList[4].conditionType} = '210' || {${prefix}.medicalConditionList[5].conditionType} = '210' || {${prefix}.medicalConditionList[6].conditionType} = '210' || {${prefix}.medicalConditionList[7].conditionType} = '210' || {${prefix}.medicalConditionList[8].conditionType} = '210' || {${prefix}.medicalConditionList[9].conditionType} = '210')`,
      isRequired: false,
      inputType: "date",
      min: "1920-01-01",
      max: new Date().toISOString().split("T")[0],
    },
    {
      type: "radiogroup",
      name: `${prefix}.coronaryArteryBypassCABG`,
      title: `Have ${youReplace} had a Coronary Artery Bypass Graft (CABG)?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '210' || {${prefix}.medicalConditionList[1].conditionType} = '210' || {${prefix}.medicalConditionList[2].conditionType} = '210' || {${prefix}.medicalConditionList[3].conditionType} = '210' || {${prefix}.medicalConditionList[4].conditionType} = '210' || {${prefix}.medicalConditionList[5].conditionType} = '210' || {${prefix}.medicalConditionList[6].conditionType} = '210' || {${prefix}.medicalConditionList[7].conditionType} = '210' || {${prefix}.medicalConditionList[8].conditionType} = '210' || {${prefix}.medicalConditionList[9].conditionType} = '210')`,
      isRequired: false,
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "text",
      name: `${prefix}.cABGDate`,
      title: `When did ${youReplace} have the bypass?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && {${prefix}.coronaryArteryBypassCABG} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '210' || {${prefix}.medicalConditionList[1].conditionType} = '210' || {${prefix}.medicalConditionList[2].conditionType} = '210' || {${prefix}.medicalConditionList[3].conditionType} = '210' || {${prefix}.medicalConditionList[4].conditionType} = '210' || {${prefix}.medicalConditionList[5].conditionType} = '210' || {${prefix}.medicalConditionList[6].conditionType} = '210' || {${prefix}.medicalConditionList[7].conditionType} = '210' || {${prefix}.medicalConditionList[8].conditionType} = '210' || {${prefix}.medicalConditionList[9].conditionType} = '210')`,
      isRequired: false,
      inputType: "date",
      min: "1920-01-01",
      max: new Date().toISOString().split("T")[0],
    },
    {
      type: "radiogroup",
      name: `${prefix}.mitralValveReplacement`,
      title: `Have ${youReplace} had a Mitral valve replacement?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '210' || {${prefix}.medicalConditionList[1].conditionType} = '210' || {${prefix}.medicalConditionList[2].conditionType} = '210' || {${prefix}.medicalConditionList[3].conditionType} = '210' || {${prefix}.medicalConditionList[4].conditionType} = '210' || {${prefix}.medicalConditionList[5].conditionType} = '210' || {${prefix}.medicalConditionList[6].conditionType} = '210' || {${prefix}.medicalConditionList[7].conditionType} = '210' || {${prefix}.medicalConditionList[8].conditionType} = '210' || {${prefix}.medicalConditionList[9].conditionType} = '210')`,
      isRequired: false,
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "radiogroup",
      name: `${prefix}.mVRSuccessful`,
      title: `Was the Mitral valve replacement successful?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && {${prefix}.mitralValveReplacement} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '210' || {${prefix}.medicalConditionList[1].conditionType} = '210' || {${prefix}.medicalConditionList[2].conditionType} = '210' || {${prefix}.medicalConditionList[3].conditionType} = '210' || {${prefix}.medicalConditionList[4].conditionType} = '210' || {${prefix}.medicalConditionList[5].conditionType} = '210' || {${prefix}.medicalConditionList[6].conditionType} = '210' || {${prefix}.medicalConditionList[7].conditionType} = '210' || {${prefix}.medicalConditionList[8].conditionType} = '210' || {${prefix}.medicalConditionList[9].conditionType} = '210')`,
      isRequired: false,
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "radiogroup",
      name: `${prefix}.tricuspidValveReplacement`,
      title: `Have ${youReplace} had a Tricuspid valve replacement?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '210' || {${prefix}.medicalConditionList[1].conditionType} = '210' || {${prefix}.medicalConditionList[2].conditionType} = '210' || {${prefix}.medicalConditionList[3].conditionType} = '210' || {${prefix}.medicalConditionList[4].conditionType} = '210' || {${prefix}.medicalConditionList[5].conditionType} = '210' || {${prefix}.medicalConditionList[6].conditionType} = '210' || {${prefix}.medicalConditionList[7].conditionType} = '210' || {${prefix}.medicalConditionList[8].conditionType} = '210' || {${prefix}.medicalConditionList[9].conditionType} = '210')`,
      isRequired: false,
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "radiogroup",
      name: `${prefix}.pacemaker`,
      title: `Have ${youReplace} had a Pacemaker fitted?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '210' || {${prefix}.medicalConditionList[1].conditionType} = '210' || {${prefix}.medicalConditionList[2].conditionType} = '210' || {${prefix}.medicalConditionList[3].conditionType} = '210' || {${prefix}.medicalConditionList[4].conditionType} = '210' || {${prefix}.medicalConditionList[5].conditionType} = '210' || {${prefix}.medicalConditionList[6].conditionType} = '210' || {${prefix}.medicalConditionList[7].conditionType} = '210' || {${prefix}.medicalConditionList[8].conditionType} = '210' || {${prefix}.medicalConditionList[9].conditionType} = '210')`,
      isRequired: false,
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "radiogroup",
      name: `${prefix}.pacemakerSuccessful`,
      title: `Was the Pacemaker fitted successfully?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && {${prefix}.pacemaker} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '210' || {${prefix}.medicalConditionList[1].conditionType} = '210' || {${prefix}.medicalConditionList[2].conditionType} = '210' || {${prefix}.medicalConditionList[3].conditionType} = '210' || {${prefix}.medicalConditionList[4].conditionType} = '210' || {${prefix}.medicalConditionList[5].conditionType} = '210' || {${prefix}.medicalConditionList[6].conditionType} = '210' || {${prefix}.medicalConditionList[7].conditionType} = '210' || {${prefix}.medicalConditionList[8].conditionType} = '210' || {${prefix}.medicalConditionList[9].conditionType} = '210')`,
      isRequired: false,
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "radiogroup",
      name: `${prefix}.cardioversionAblation`,
      title: `Have ${youReplace} had a Cardioversion or Ablation procedure?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '210' || {${prefix}.medicalConditionList[1].conditionType} = '210' || {${prefix}.medicalConditionList[2].conditionType} = '210' || {${prefix}.medicalConditionList[3].conditionType} = '210' || {${prefix}.medicalConditionList[4].conditionType} = '210' || {${prefix}.medicalConditionList[5].conditionType} = '210' || {${prefix}.medicalConditionList[6].conditionType} = '210' || {${prefix}.medicalConditionList[7].conditionType} = '210' || {${prefix}.medicalConditionList[8].conditionType} = '210' || {${prefix}.medicalConditionList[9].conditionType} = '210')`,
      isRequired: false,
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "text",
      name: `${prefix}.cardioversionDate`,
      title: `When did ${youReplace} have the Cardioversion or Ablation procedure?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && {${prefix}.cardioversionAblation} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '210' || {${prefix}.medicalConditionList[1].conditionType} = '210' || {${prefix}.medicalConditionList[2].conditionType} = '210' || {${prefix}.medicalConditionList[3].conditionType} = '210' || {${prefix}.medicalConditionList[4].conditionType} = '210' || {${prefix}.medicalConditionList[5].conditionType} = '210' || {${prefix}.medicalConditionList[6].conditionType} = '210' || {${prefix}.medicalConditionList[7].conditionType} = '210' || {${prefix}.medicalConditionList[8].conditionType} = '210' || {${prefix}.medicalConditionList[9].conditionType} = '210')`,
      isRequired: false,
      inputType: "date",
      min: "1920-01-01",
      max: new Date().toISOString().split("T")[0],
    },
    {
      type: "radiogroup",
      name: `${prefix}.cardioversionSuccessful`,
      title: `Was the Cardioversion or Ablation procedure successful?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && {${prefix}.cardioversionAblation} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '210' || {${prefix}.medicalConditionList[1].conditionType} = '210' || {${prefix}.medicalConditionList[2].conditionType} = '210' || {${prefix}.medicalConditionList[3].conditionType} = '210' || {${prefix}.medicalConditionList[4].conditionType} = '210' || {${prefix}.medicalConditionList[5].conditionType} = '210' || {${prefix}.medicalConditionList[6].conditionType} = '210' || {${prefix}.medicalConditionList[7].conditionType} = '210' || {${prefix}.medicalConditionList[8].conditionType} = '210' || {${prefix}.medicalConditionList[9].conditionType} = '210')`,
      isRequired: false,
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "radiogroup",
      name: `${prefix}.aorticAneurysmRepair`,
      title: `Have ${youReplace} had a procedure to repair an Aortic Aneurysm?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '210' || {${prefix}.medicalConditionList[1].conditionType} = '210' || {${prefix}.medicalConditionList[2].conditionType} = '210' || {${prefix}.medicalConditionList[3].conditionType} = '210' || {${prefix}.medicalConditionList[4].conditionType} = '210' || {${prefix}.medicalConditionList[5].conditionType} = '210' || {${prefix}.medicalConditionList[6].conditionType} = '210' || {${prefix}.medicalConditionList[7].conditionType} = '210' || {${prefix}.medicalConditionList[8].conditionType} = '210' || {${prefix}.medicalConditionList[9].conditionType} = '210')`,
      isRequired: false,
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "text",
      name: `${prefix}.aARDate`,
      title: `When did ${youReplace} have the Aortic Aneurysm repair procedure?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && {${prefix}.aorticAneurysmRepair} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '210' || {${prefix}.medicalConditionList[1].conditionType} = '210' || {${prefix}.medicalConditionList[2].conditionType} = '210' || {${prefix}.medicalConditionList[3].conditionType} = '210' || {${prefix}.medicalConditionList[4].conditionType} = '210' || {${prefix}.medicalConditionList[5].conditionType} = '210' || {${prefix}.medicalConditionList[6].conditionType} = '210' || {${prefix}.medicalConditionList[7].conditionType} = '210' || {${prefix}.medicalConditionList[8].conditionType} = '210' || {${prefix}.medicalConditionList[9].conditionType} = '210')`,
      isRequired: false,
      inputType: "date",
      min: "1920-01-01",
      max: new Date().toISOString().split("T")[0],
    },
    {
      type: "radiogroup",
      name: `${prefix}.aARSuccessful`,
      title: `Was the Aortic Aneurysm repair procedure successful?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && {${prefix}.aorticAneurysmRepair} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '210' || {${prefix}.medicalConditionList[1].conditionType} = '210' || {${prefix}.medicalConditionList[2].conditionType} = '210' || {${prefix}.medicalConditionList[3].conditionType} = '210' || {${prefix}.medicalConditionList[4].conditionType} = '210' || {${prefix}.medicalConditionList[5].conditionType} = '210' || {${prefix}.medicalConditionList[6].conditionType} = '210' || {${prefix}.medicalConditionList[7].conditionType} = '210' || {${prefix}.medicalConditionList[8].conditionType} = '210' || {${prefix}.medicalConditionList[9].conditionType} = '210')`,
      isRequired: false,
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "radiogroup",
      name: `${prefix}.visionImpairment`,
      title: `Have ${youReplace} suffered from vision impairment due to the stroke(s)?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '213' || {${prefix}.medicalConditionList[1].conditionType} = '213' || {${prefix}.medicalConditionList[2].conditionType} = '213' || {${prefix}.medicalConditionList[3].conditionType} = '213' || {${prefix}.medicalConditionList[4].conditionType} = '213' || {${prefix}.medicalConditionList[5].conditionType} = '213' || {${prefix}.medicalConditionList[6].conditionType} = '213' || {${prefix}.medicalConditionList[7].conditionType} = '213' || {${prefix}.medicalConditionList[8].conditionType} = '213' || {${prefix}.medicalConditionList[9].conditionType} = '213')`,
      isRequired: false,
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "radiogroup",
      name: `${prefix}.speechDifficulties`,
      title: `Have ${youReplace} suffered from speech difficulties due to the stroke(s)?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '213' || {${prefix}.medicalConditionList[1].conditionType} = '213' || {${prefix}.medicalConditionList[2].conditionType} = '213' || {${prefix}.medicalConditionList[3].conditionType} = '213' || {${prefix}.medicalConditionList[4].conditionType} = '213' || {${prefix}.medicalConditionList[5].conditionType} = '213' || {${prefix}.medicalConditionList[6].conditionType} = '213' || {${prefix}.medicalConditionList[7].conditionType} = '213' || {${prefix}.medicalConditionList[8].conditionType} = '213' || {${prefix}.medicalConditionList[9].conditionType} = '213')`,
      isRequired: false,
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "radiogroup",
      name: `${prefix}.paralysisLeg`,
      title: `Have ${youReplace} suffered from paralysis in the legs due to the stroke(s)?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '213' || {${prefix}.medicalConditionList[1].conditionType} = '213' || {${prefix}.medicalConditionList[2].conditionType} = '213' || {${prefix}.medicalConditionList[3].conditionType} = '213' || {${prefix}.medicalConditionList[4].conditionType} = '213' || {${prefix}.medicalConditionList[5].conditionType} = '213' || {${prefix}.medicalConditionList[6].conditionType} = '213' || {${prefix}.medicalConditionList[7].conditionType} = '213' || {${prefix}.medicalConditionList[8].conditionType} = '213' || {${prefix}.medicalConditionList[9].conditionType} = '213')`,
      isRequired: false,
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "radiogroup",
      name: `${prefix}.paralysisArm`,
      title: `Have ${youReplace} suffered from paralysis in the arms due to the stroke(s)?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '213' || {${prefix}.medicalConditionList[1].conditionType} = '213' || {${prefix}.medicalConditionList[2].conditionType} = '213' || {${prefix}.medicalConditionList[3].conditionType} = '213' || {${prefix}.medicalConditionList[4].conditionType} = '213' || {${prefix}.medicalConditionList[5].conditionType} = '213' || {${prefix}.medicalConditionList[6].conditionType} = '213' || {${prefix}.medicalConditionList[7].conditionType} = '213' || {${prefix}.medicalConditionList[8].conditionType} = '213' || {${prefix}.medicalConditionList[9].conditionType} = '213')`,
      isRequired: false,
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "radiogroup",
      name: `${prefix}.memoryLoss`,
      title: `Have ${youReplace} suffered from memory Loss due to the stroke(s)?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({${prefix}.medicalConditionList[0].conditionType} = '213' || {${prefix}.medicalConditionList[1].conditionType} = '213' || {${prefix}.medicalConditionList[2].conditionType} = '213' || {${prefix}.medicalConditionList[3].conditionType} = '213' || {${prefix}.medicalConditionList[4].conditionType} = '213' || {${prefix}.medicalConditionList[5].conditionType} = '213' || {${prefix}.medicalConditionList[6].conditionType} = '213' || {${prefix}.medicalConditionList[7].conditionType} = '213' || {${prefix}.medicalConditionList[8].conditionType} = '213' || {${prefix}.medicalConditionList[9].conditionType} = '213')`,
      isRequired: false,
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
  ];
}

export function getMedicalInfoSchema(isPerson2: boolean) {
  const prefix = isPerson2 ? "person2MedicalInformation" : "medicalInformation";
  const personText = isPerson2 ? "they" : "you";
  let yourReplace = isPerson2 ? "their" : "your";
  let youReplace = isPerson2 ? "they" : "you";

  return {
    name: isPerson2 ? "person2MedicalDetails" : "person1MedicalDetails",
    title: isPerson2
      ? "Spouse or Partner Health & Lifestyle"
      : "Your Health & Lifestyle",
    description: `A few more details about ${
      isPerson2 ? "your spouse or partner's" : "your"
    } health and lifestyle`,
    visibleIf: isPerson2 ? "{client1OrJoint} = '1496'" : "",
    elements: [
      {
        type: "radiogroup",
        name: `${prefix}.lifestyleAndMedicalDeclaration`,
        title: `Do ${youReplace} consent to share medical and lifestyle information with providers in order to generate quotes?`,
        description:
          "If you do not consent to share your medical and lifestyle information, the quotes you receive will not be tailored and could result in a lower amount.",
        isRequired: true,
        colCount: 2,
        choices: [
          { value: "true", text: "Yes" },
          { value: "false", text: "No" },
        ],
      },
      {
        type: "panel",
        name: "heightPanel",
        title: `What is ${yourReplace} height, weight and waist measurement?`,
        visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true'`,
        elements: [
          {
            type: "dropdown",
            name: `${prefix}.measurementUnitsID`,
            title: "Unit of measurement",
            isRequired: true,
            choices: [
              { value: "100990", text: "Imperial" },
              { value: "100991", text: "Metric" },
            ],
          },
          {
            type: "text",
            name: `${prefix}.heightFeet`,
            title: "Height feet",
            isRequired: true,
            inputType: "number",
            min: 2,
            max: 8,
            colCount: 6,
            validators: [
              {
                type: "regex",
                text: "Please enter a value between 2 and 8.",
                regex: "^[2-8]$",
              },
            ],
            visibleIf: `{${prefix}.measurementUnitsID} = '100990'`,
            prefix: "ft:",
          },
          {
            type: "text",
            name: `${prefix}.heightInches`,
            title: "Inches",
            isRequired: true,
            inputType: "number",
            min: 0,
            max: 11,
            colCount: 6,
            startWithNewLine: false,
            validators: [
              {
                type: "regex",
                text: "Please enter a value between 0 and 11.",
                regex: "^([0-9]|1[0-1])$",
              },
            ],
            visibleIf: `{${prefix}.measurementUnitsID} = '100990'`,
          },
          {
            type: "text",
            name: `${prefix}.heightCm`,
            title: "Height cm",
            isRequired: true,
            inputType: "number",
            min: 10,
            max: 300,
            colCount: 6,
            validators: [
              {
                type: "regex",
                text: "Please enter a value between 10 and 300.",
                regex: "^(1[0-9]{2}|2[0-9]{2}|300|10)$",
              },
            ],
            visibleIf: `{${prefix}.measurementUnitsID} = '100991'`,
          },
          {
            type: "text",
            name: `${prefix}.weightStone`,
            title: "Weight stone",
            isRequired: true,
            inputType: "number",
            min: 1,
            max: 100,
            colCount: 6,
            startWithNewLine: true,
            validators: [
              {
                type: "regex",
                text: "Please enter a value between 1 and 100.",
                regex: "^([1-9]|[1-9][0-9]|100)$",
              },
            ],
            visibleIf: `{${prefix}.measurementUnitsID} = '100990'`,
          },
          {
            type: "text",
            name: `${prefix}.weightPounds`,
            title: "Pounds",
            isRequired: true,
            inputType: "number",
            min: 0,
            max: 100,
            colCount: 6,
            startWithNewLine: false,
            validators: [
              {
                type: "regex",
                text: "Please enter a value between 0 and 100.",
                regex: "^([0-9]|[1-9][0-9]|100)$",
              },
            ],
            visibleIf: `{${prefix}.measurementUnitsID} = '100990'`,
          },
          {
            type: "text",
            name: `${prefix}.weightKg`,
            title: "Weight kg",
            isRequired: true,
            inputType: "number",
            min: 1,
            max: 500,
            colCount: 6,
            startWithNewLine: true,
            validators: [
              {
                type: "regex",
                text: "Please enter a value between 1 and 500.",
                regex: "^([1-9]|[1-9][0-9]|[1-4][0-9]{2}|500)$",  
              },
            ],
            visibleIf: `{${prefix}.measurementUnitsID} = '100991'`,
          },
          {
            type: "text",
            name: `${prefix}.waistMeasurement`,
            title: `What is ${yourReplace} waist measurement? (inches)`,
            moreInfo: "waistMeasurementTooltip",
            moreInfoMode: "tray",
            isRequired: true,
            inputType: "number",
            min: 1,
            max: 500,
            validators: [
              {
                type: "regex",
                text: "Please enter a value between 1 and 500.",
                regex: "^([1-9]|[1-9][0-9]|[1-4][0-9]{2}|500)$",
              },
            ],
            prefix: "Inches:",
            visibleIf: `{${prefix}.measurementUnitsID} = '100990'`,
          },
          {
            type: "text",
            name: `${prefix}.waistMeasurementCm`,
            title: `What is ${yourReplace} waist measurement? (cm)`,
            moreInfo: "waistMeasurementTooltip",
            moreInfoMode: "tray",
            isRequired: true,
            inputType: "number",
            min: 1,
            max: 500,
            validators: [
              {
                type: "regex",
                text: "Please enter a value between 1 and 500.",
                regex: "^([1-9]|[1-9][0-9]|[1-4][0-9]{2}|500)$",
              },
            ],
            prefix: "cm:",
            visibleIf: `{${prefix}.measurementUnitsID} = '100991'`,
          },
        ],
      },
      {
        type: "radiogroup",
        name: `${prefix}.previousOrCurrentSmokerYesNo`,
        title: `Have ${youReplace} ever been a smoker?`,
        visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true'`,
        isRequired: false,
        colCount: 2,
        description: `If ${youReplace} are a smoker or have been previously, this can increase the amount you receive.`,
        choices: [
          { value: "true", text: "Yes" },
          { value: "false", text: "No" },
        ],
      },
      {
        type: "text",
        name: `${prefix}.yearMonthStartedSmoking`,
        title: `When did ${youReplace} start smoking?`,
        visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && {${prefix}.previousOrCurrentSmokerYesNo} = 'true'`,
        isRequired: true,
        inputType: "date",
        min: "1920-01-01",
        max: new Date().toISOString().split("T")[0],
        description: "A rough estimate will be fine.",
      },
      {
        type: "radiogroup",
        name: `${prefix}.previousSmokerYesNo`,
        title: `Have ${youReplace} now stopped smoking?`,
        visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && {${prefix}.previousOrCurrentSmokerYesNo} = 'true'`,
        isRequired: false,
        colCount: 2,
        choices: [
          { value: "true", text: "Yes" },
          { value: "false", text: "No" },
        ],
      },
      {
        type: "text",
        name: `${prefix}.yearMonthStoppedSmoking`,
        title: `When did ${youReplace} stop smoking?`,
        visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && {${prefix}.previousOrCurrentSmokerYesNo} = 'true' && {${prefix}.previousSmokerYesNo} = 'true'`,
        isRequired: true,
        inputType: "date",
        min: "1920-01-01",
        max: new Date().toISOString().split("T")[0],
        description: "A rough estimate will be fine.",
      },
      {
        type: "radiogroup",
        name: `${prefix}.regularSmoker`,
        title: `Have ${youReplace} been a regular smoker over the last 10 years?`,
        visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && {${prefix}.previousOrCurrentSmokerYesNo} = 'true'`,
        isRequired: false,
        colCount: 2,
        choices: [
          { value: "true", text: "Yes" },
          { value: "false", text: "No" },
        ],
      },

      {
        type: "text",
        name: `${prefix}.cigarettesPerDay`,
        title: "Cigarettes Per Day",
        visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && {${prefix}.previousOrCurrentSmokerYesNo} = 'true'`,
        isRequired: false,
        inputType: "number",
        min: 0,
        max: 200,
        validators: [
          {
            type: "regex",
            text: "Please enter a value between 0 and 200.",
            regex: "^([0-9]|[1-9][0-9]|1[0-9][0-9]|200)$",
          },
        ],
      },
      {
        type: "text",
        name: `${prefix}.cigarsPerDay`,
        title: "Cigars Per Day",
        visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && {${prefix}.previousOrCurrentSmokerYesNo} = 'true'`,
        isRequired: false,
        inputType: "number",
        min: 0,
        max: 50,
        validators: [
          {
            type: "regex",
            text: "Please enter a value between 0 and 50.",
            regex: "^([0-9]|[1-4][0-9]|50)$",
          },
        ],
      },
      {
        type: "text",
        name: `${prefix}.gramsOfTobaccoPerDay`,
        title: "Grams Of Tobacco Per Day",
        visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && {${prefix}.previousOrCurrentSmokerYesNo} = 'true'`,
        isRequired: false,
        inputType: "number",
        min: 0,
        max: 1000,
        validators: [
          {
            type: "regex",
            text: "Please enter a value between 0 and 1000.",
            regex: "^([0-9]|[1-9][0-9]|[1-9][0-9][0-9]|1000)$",
          },
        ],
      },
      {
        type: "text",
        name: `${prefix}.gramsOfPipeTobaccoPerDay`,
        title: "Grams Of Pipe Tobacco Per Day",
        visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && {${prefix}.previousOrCurrentSmokerYesNo} = 'true'`,
        isRequired: false,
        inputType: "number",
        min: 0,
        max: 1000,
        validators: [
          {
            type: "regex",
            text: "Please enter a value between 0 and 1000.",
            regex: "^([0-9]|[1-9][0-9]|[1-9][0-9][0-9]|1000)$",
          },
        ],
      },
      {
        type: "text",
        name: `${prefix}.alcoholUnitsPerWeek`,
        title: `How many units of alcohol do ${youReplace} drink per week?`,
        visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true'`,
        isRequired: false,
        inputType: "number",
        min: 0,
        max: 999,
        description:
          "1 pint of beer is 3 units, a single shot of spirit is 1 unit and a glass of wine is 2 units.",
        validators: [
          {
            type: "regex",
            text: "Please enter a value between 0 and 999.",
            regex: "^([0-9]|[1-9][0-9]|[1-9][0-9][0-9])$",
          },
        ],
      },
      {
        type: "panel",
        name: `${prefix}.medicalConditionsPanel`,
        visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true'`,
        elements: [
          {
            type: "html",
            name: `${prefix}.medicalConditionsInfo`,
            html: `<div class="notice rounded border-dashed p-md-10 p-sm-5 p-4 bg-light-warning rounded border-dark mt-9 mb-9 mb-10">
              <p style="margin-bottom: 10px;"><strong>Important:</strong> Including medical conditions can significantly increase your rates. Please consider adding conditions such as:</p>
              <ul style="margin-bottom: 10px; padding-left: 20px;">
                <li>Asthma</li>
                <li>High blood pressure</li>
                <li>Cancer</li>
                <li>Heart problems</li>
                <li>Diabetes</li>
                <li>Multiple Sclerosis</li>
                <li>Stroke</li>
                <li>Neurological conditions</li>
              </ul>
              <p style="margin-bottom: 0;"><strong>No pressure!</strong> You can either fill in what you know now (skipping any uncertain details), or simply speak with one of our advisers who can help add your conditions for you.</p>
            </div>`,
          },
          {
            type: "radiogroup",
            name: `${prefix}.medicalConditionsYesNo`,
            title: `Do ${youReplace} want to add any past or present medical conditions?`,
            isRequired: true,
            colCount: 2,
            choices: [
              { value: "true", text: "Yes" },
              { value: "false", text: "No" },
            ],
          },
        ],
      },
      {
        type: "paneldynamic",
        name: `${prefix}.medicalConditionList`,
        title: "Medical Conditions",
        visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && {${prefix}.medicalConditionsYesNo} = 'true'`,
        templateElements: getMedicalConditionElements(prefix, isPerson2),
        templateTitle: "{panel.conditionType}",
        maxPanelCount: 10,
        // displayMode: "tab",
        panelCount: 1,
        panelsState: "firstExpanded",
        confirmDelete: true,
        removePanelText: "Remove This Condition",
        templateTabTitle: "{panel.conditionType}",
        tabTitlePlaceholder: "New Condition",
        showProgressBar: false,
        newPanelPosition: "next",
        valueName: `${prefix}.medicalConditionList`,
        defaultValue: [],
        allowAddPanel: true,
        allowRemovePanel: true,
        panelAddText: "Add Another Condition",
        panelRemoveText: "Remove This Condition",
        // renderMode: "tab",
        keyName: "id",
        keyDuplicationError: "Please enter a unique value.",
        defaultPanelValue: {
          conditionType: "",
          conditionDescription: "",
          conditionDate: "",
        },
      },
      ...getSharedMedicalInfoElements(prefix, isPerson2),
      {
        type: "radiogroup",
        name: `${prefix}.medicationsYesNo`,
        title: `Do ${youReplace} take any medications?`,
        isRequired: true,
        colCount: 2,
        visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && {${prefix}.medicalConditionsYesNo} = 'true' && {${prefix}.medicalConditionList.length} > 0`,
        choices: [
          { value: "true", text: "Yes" },
          { value: "false", text: "No" },
        ],
      },
      {
        type: "paneldynamic",
        name: `${prefix}.medicationList`,
        title: "Medications",
        visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && {${prefix}.medicationsYesNo} = 'true' && {${prefix}.medicalConditionList.length} > 0`,

        templateElements: [
          {
            name: "forConditionType",
            title: `Which of ${youReplace} condition types is this medication for?`,
            type: "dropdown",
            isRequired: true,
            visibleIf: `{${prefix}.medicalConditionList.length} > 0`,
            choices: [
              { value: "-1", text: "Please select..." },
              {
                value: "4163",
                text: "Other",
                visibleIf: `{${prefix}.medicalConditionList[0].conditionType} = "208" || {${prefix}.medicalConditionList[1].conditionType} = "208" || {${prefix}.medicalConditionList[2].conditionType} = "208" || {${prefix}.medicalConditionList[3].conditionType} = "208" || {${prefix}.medicalConditionList[4].conditionType} = "208" || {${prefix}.medicalConditionList[5].conditionType} = "208" || {${prefix}.medicalConditionList[6].conditionType} = "208" || {${prefix}.medicalConditionList[7].conditionType} = "208" || {${prefix}.medicalConditionList[8].conditionType} = "208" || {${prefix}.medicalConditionList[9].conditionType} = "208"`,
              },
              {
                value: "4165",
                text: "Heart",
                visibleIf: `{${prefix}.medicalConditionList[0].conditionType} = "210" || {${prefix}.medicalConditionList[1].conditionType} = "210" || {${prefix}.medicalConditionList[2].conditionType} = "210" || {${prefix}.medicalConditionList[3].conditionType} = "210" || {${prefix}.medicalConditionList[4].conditionType} = "210" || {${prefix}.medicalConditionList[5].conditionType} = "210" || {${prefix}.medicalConditionList[6].conditionType} = "210" || {${prefix}.medicalConditionList[7].conditionType} = "210" || {${prefix}.medicalConditionList[8].conditionType} = "210" || {${prefix}.medicalConditionList[9].conditionType} = "210"`,
              },
              {
                value: "4167",
                text: "Diabetes",
                visibleIf: `{${prefix}.medicalConditionList[0].conditionType} = "211" || {${prefix}.medicalConditionList[1].conditionType} = "211" || {${prefix}.medicalConditionList[2].conditionType} = "211" || {${prefix}.medicalConditionList[3].conditionType} = "211" || {${prefix}.medicalConditionList[4].conditionType} = "211" || {${prefix}.medicalConditionList[5].conditionType} = "211" || {${prefix}.medicalConditionList[6].conditionType} = "211" || {${prefix}.medicalConditionList[7].conditionType} = "211" || {${prefix}.medicalConditionList[8].conditionType} = "211" || {${prefix}.medicalConditionList[9].conditionType} = "211"`,
              },
              {
                value: "4161",
                text: "Cancer/Tumour",
                visibleIf: `{${prefix}.medicalConditionList[0].conditionType} = "212" || {${prefix}.medicalConditionList[1].conditionType} = "212" || {${prefix}.medicalConditionList[2].conditionType} = "212" || {${prefix}.medicalConditionList[3].conditionType} = "212" || {${prefix}.medicalConditionList[4].conditionType} = "212" || {${prefix}.medicalConditionList[5].conditionType} = "212" || {${prefix}.medicalConditionList[6].conditionType} = "212" || {${prefix}.medicalConditionList[7].conditionType} = "212" || {${prefix}.medicalConditionList[8].conditionType} = "212" || {${prefix}.medicalConditionList[9].conditionType} = "212"`,
              },
              {
                value: "4172",
                text: "Stroke",
                visibleIf: `{${prefix}.medicalConditionList[0].conditionType} = "213" || {${prefix}.medicalConditionList[1].conditionType} = "213" || {${prefix}.medicalConditionList[2].conditionType} = "213" || {${prefix}.medicalConditionList[3].conditionType} = "213" || {${prefix}.medicalConditionList[4].conditionType} = "213" || {${prefix}.medicalConditionList[5].conditionType} = "213" || {${prefix}.medicalConditionList[6].conditionType} = "213" || {${prefix}.medicalConditionList[7].conditionType} = "213" || {${prefix}.medicalConditionList[8].conditionType} = "213" || {${prefix}.medicalConditionList[9].conditionType} = "213"`,
              },
              {
                value: "4169",
                text: "Respiratory",
                visibleIf: `{${prefix}.medicalConditionList[0].conditionType} = "214" || {${prefix}.medicalConditionList[1].conditionType} = "214" || {${prefix}.medicalConditionList[2].conditionType} = "214" || {${prefix}.medicalConditionList[3].conditionType} = "214" || {${prefix}.medicalConditionList[4].conditionType} = "214" || {${prefix}.medicalConditionList[5].conditionType} = "214" || {${prefix}.medicalConditionList[6].conditionType} = "214" || {${prefix}.medicalConditionList[7].conditionType} = "214" || {${prefix}.medicalConditionList[8].conditionType} = "214" || {${prefix}.medicalConditionList[9].conditionType} = "214"`,
              },
              {
                value: "5983",
                text: "Multiple Sclerosis",
                visibleIf: `{${prefix}.medicalConditionList[0].conditionType} = "215" || {${prefix}.medicalConditionList[1].conditionType} = "215" || {${prefix}.medicalConditionList[2].conditionType} = "215" || {${prefix}.medicalConditionList[3].conditionType} = "215" || {${prefix}.medicalConditionList[4].conditionType} = "215" || {${prefix}.medicalConditionList[5].conditionType} = "215" || {${prefix}.medicalConditionList[6].conditionType} = "215" || {${prefix}.medicalConditionList[7].conditionType} = "215" || {${prefix}.medicalConditionList[8].conditionType} = "215" || {${prefix}.medicalConditionList[9].conditionType} = "215"`,
              },
              {
                value: "4170",
                text: "Neurological",
                visibleIf: `{${prefix}.medicalConditionList[0].conditionType} = "216" || {${prefix}.medicalConditionList[1].conditionType} = "216" || {${prefix}.medicalConditionList[2].conditionType} = "216" || {${prefix}.medicalConditionList[3].conditionType} = "216" || {${prefix}.medicalConditionList[4].conditionType} = "216" || {${prefix}.medicalConditionList[5].conditionType} = "216" || {${prefix}.medicalConditionList[6].conditionType} = "216" || {${prefix}.medicalConditionList[7].conditionType} = "216" || {${prefix}.medicalConditionList[8].conditionType} = "216" || {${prefix}.medicalConditionList[9].conditionType} = "216"`,
              },
              {
                value: "5873",
                text: "High Blood Pressure",
                visibleIf: `{${prefix}.medicalConditionList[0].conditionType} = "218" || {${prefix}.medicalConditionList[1].conditionType} = "218" || {${prefix}.medicalConditionList[2].conditionType} = "218" || {${prefix}.medicalConditionList[3].conditionType} = "218" || {${prefix}.medicalConditionList[4].conditionType} = "218" || {${prefix}.medicalConditionList[5].conditionType} = "218" || {${prefix}.medicalConditionList[6].conditionType} = "218" || {${prefix}.medicalConditionList[7].conditionType} = "218" || {${prefix}.medicalConditionList[8].conditionType} = "218" || {${prefix}.medicalConditionList[9].conditionType} = "218"`,
              },
              {
                value: "5874",
                text: "High Cholesterol",
                visibleIf: `{${prefix}.medicalConditionList[0].conditionType} = "219" || {${prefix}.medicalConditionList[1].conditionType} = "219" || {${prefix}.medicalConditionList[2].conditionType} = "219" || {${prefix}.medicalConditionList[3].conditionType} = "219" || {${prefix}.medicalConditionList[4].conditionType} = "219" || {${prefix}.medicalConditionList[5].conditionType} = "219" || {${prefix}.medicalConditionList[6].conditionType} = "219" || {${prefix}.medicalConditionList[7].conditionType} = "219" || {${prefix}.medicalConditionList[8].conditionType} = "219" || {${prefix}.medicalConditionList[9].conditionType} = "219"`,
              },
            ],
          },

          // Medication Select with custom select component -db
          // {
          //   type: "medicationselect",
          //   name: "medicationName",
          //   title: "What is the name of the medication?",
          //   isRequired: true,
          //   dataset1: "meddata",
          //   category: `Heart`
          // },

          // {
          //   type: "dropdown",
          //   name: "medicationName",
          //   title: "What is the name of the medication?",
          //   isRequired: true,
          //   placeholder: "Please Select",
          //   choicesLazyLoadEnabled: true,
          //   choicesLazyLoadPageSize: 10,
          // },

          {
            type: "dropdown",
            name: "medicationName",
            title: "Start typing the name of the medication",
            lazyLoad: true,
            choicesLazyLoadEnabled: true,
            choicesLazyLoadPageSize: 10,
            choicesURL: `${APIURL}/medical/medications`,
            displayValuesURL: `${APIURL}/medical/medicationnamefromid`,
            takeParameterName: "take",
            choicesFilterParameterName: "labelFilter",
            displayValuesFilterParameterName: "medicationID",
            placeholder: "Please start typing to search...",
          },

          {
            type: "dropdown",
            name: "frequency",
            title: `How often do ${youReplace} take the medication?`,
            isRequired: true,
            choices: [
              { value: "5833", text: "As Required" },
              { value: "5984", text: "Daily" },
              { value: "5985", text: "Weekly" },
              { value: "5986", text: "Fortnightly" },
              { value: "5987", text: "Every Four Weeks" },
              { value: "5988", text: "Monthly" },
              { value: "5989", text: "Quarterly" },
              { value: "5990", text: "Half Yearly" },
              { value: "5991", text: "Yearly" },
            ],
          },
          {
            type: "text",
            name: "numberTaken",
            title: `How many do ${youReplace} take?`,
            isRequired: false,
            inputType: "number",
            validators: [
              {
                type: "regex",
                text: "Please enter a number greater than zero.",
                regex: "^[1-9][0-9]*$",
              },
            ],
            startWithNewLine: false,
          },
          {
            type: "radiogroup",
            name: "dosageKnown",
            title: `Do ${youReplace} know the exact dosage for this medication?`,
            isRequired: false,
            colCount: 2,
            choices: [
              { value: "true", text: "Yes" },
              { value: "false", text: "No" },
            ],
          },
          {
            type: "panel",
            name: "dosageAmountPanel",
            title: "",
            visibleIf: "{panel.dosageKnown} = 'true'",
            elements: [
              {
                type: "text",
                name: "dosage",
                title: `What dosage do ${youReplace} take?`,
                isRequired: false,
                inputType: "number",
                validators: [
                  {
                    type: "regex",
                    text: "Please enter a number greater than zero.",
                    regex: "^[0-9]+(\\.[0-9]+)?$",
                  },
                ],
                startWithNewLine: false,
                width: "50%",
              },
              {
                type: "dropdown",
                name: "dosageUnit",
                title: "Unit",
                isRequired: false,
                choices: [
                  { value: "5992", text: "Gram" },
                  { value: "5993", text: "Milligram" },
                  { value: "5994", text: "Microgram" },
                  { value: "5995", text: "Millilitre" },
                  { value: "5996", text: "Unit Of Insulin" },
                ],
                startWithNewLine: false,
                width: "50%",
              },
            ],
          },

          {
            type: "text",
            name: "startDate",
            title: `When did ${youReplace} start taking the medication?`,
            isRequired: false,
            inputType: "date",
            min: "1920-01-01",
            max: new Date().toISOString().split("T")[0],
          },
          {
            type: "radiogroup",
            name: "stillTakeMedication",
            title: `Do ${youReplace} still take this medication?`,
            isRequired: false,
            colCount: 2,
            choices: [
              { value: "true", text: "Yes" },
              { value: "false", text: "No" },
            ],
          },
          {
            type: "text",
            name: "endDate",
            title: `When did ${youReplace} stop taking the medication?`,
            isRequired: false,
            inputType: "date",
            min: "1920-01-01",
            max: new Date().toISOString().split("T")[0],
            visibleIf: "{stillTakeMedication} = 'false'",
          },
        ],
        templateTitle: "{panel.medicationName}",
        maxPanelCount: 10,
        confirmDelete: true,
        addPanelText: "Add Another Medication",
        removePanelText: "Remove This Medication",
        panelAddText: "Add Another Medication",
        panelRemoveText: "Remove This Medication",
        panelPrevText: "Previous Medication",
        panelNextText: "Next Medication",
        defaultValue: [],
        panelCount: 1,
        panelsState: "firstExpanded",
      },
    ],
  };
}

export const AnnuityQuotePerson1MedSchema = getMedicalInfoSchema(false);
export const AnnuityQuotePerson2MedSchema = getMedicalInfoSchema(true);
